export const baseUri = 'http://painel.icomp.com.br/wp-json/icomp';

export const baseUriWp = 'http://painel.icomp.com.br/wp-json/wp/v2';